module.exports = __webpack_public_path__ + "img/tester-teacher.70c44c3d.jpg";